import { createApi } from '@reduxjs/toolkit/query/react';

import { KEEP_UNUSED_DATA_FOR } from '@shared/api/api.constants';
import { fetchBaseQueryWithTokenCheck } from '@shared/utils/api.utils';

import { getTraceEntriesCacheKey } from './inquiry-findings.api.utils';
import type { InquiryTraceEntriesParams, InquiryHeader, InquiryTraceEntriesResponse } from './inquiry-findings.types';

export const inquiryFindingsApiSlice = createApi({
  reducerPath: 'inquiryFindingsApi',
  baseQuery: fetchBaseQueryWithTokenCheck,
  endpoints: (builder) => ({
    getInquiryHeader: builder.query<InquiryHeader, string>({
      query: (inquiryId) => `/api/inquiry/v1/${inquiryId}/header`,
      keepUnusedDataFor: KEEP_UNUSED_DATA_FOR,
    }),
    getInquiryTraceEntries: builder.query<InquiryTraceEntriesResponse, InquiryTraceEntriesParams>({
      query: ({ inquiryId, ...params }) => ({ url: `/api/inquiry/v1/${inquiryId}`, params }),
      serializeQueryArgs: ({ queryArgs }) => getTraceEntriesCacheKey(queryArgs),
      keepUnusedDataFor: KEEP_UNUSED_DATA_FOR,
    }),
  }),
});

export const { useGetInquiryHeaderQuery, useLazyGetInquiryTraceEntriesQuery } = inquiryFindingsApiSlice;
